<script setup>
import {onMounted} from 'vue'
import {Device} from '@/paks/mgr-models'
import {Progress, navigate} from '@/paks/vu-app'

const emit = defineEmits(['update:modelValue'])

const props = defineProps({
    items: Array,
    model: String,
    title: String,
})

onMounted(async () => {
    try {
        for (let item of props.items) {
            Progress.start('dialog', `Releasing ${item.id}`)
            await Device.remove({id: item.id})
        }
        emit('update:modelValue')
        go({name: 'devices'})
    } catch (err) {
        console.error(err.message)
    } finally {
        Progress.stop()
    }
})
</script>

<template>
    <div/>
</template>
